import React, { useCallback, useEffect, useState } from 'react';

import { Dialog, useDialogUIState } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { useNetworkContext } from 'state/network';

function ErrorNetwork() {
  const { formatMessage } = useIntl();
  const dialog = useDialogUIState();
  const { hasNetworkError } = useNetworkContext();
  const [browsingOffline, setBrowsingOffline] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);

  const onReload = useCallback(() => {
    if (window && window.location) {
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (!hasOpened && hasNetworkError && !browsingOffline) {
      setHasOpened(true);
      dialog.show();
    }
  }, [browsingOffline, dialog, hasNetworkError, hasOpened]);

  return (
    <Dialog
      data-testid="error-network-dialog"
      dialog={dialog}
      headerText={formatMessage({ id: 'lostNetworkConnectivity' })}
      bodyText={formatMessage({ id: 'checkNetworkSettings' })}
      {...{ 'aria-label': formatMessage({ id: 'lostNetworkConnectivity' }) }}
      closeButtonText={formatMessage({ id: 'close' })}
      onDismiss={() => setBrowsingOffline(true)}
      buttons={[
        {
          text: formatMessage({ id: 'reload' }),
          onClick: onReload,
        },
      ]}
    />
  );
}

export default ErrorNetwork;
